function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SearchField from "../components/TableSearchField";
import MultiSelectList from "../components/MultiSelectList";
import { arrayMove, getFullDisplayPreference } from "./utils";
export default (function (props) {
  var className = props.className,
      displayPreferences = props.displayPreferences,
      updateDisplayPreferences = props.updateDisplayPreferences,
      updatePreferencesOnChange = props.updatePreferencesOnChange,
      maxContentHeight = props.maxContentHeight,
      minContentHeight = props.minContentHeight;
  return React.createElement(TableDisplaySettings, {
    className: className,
    options: displayPreferences,
    updateDisplayPreferences: updateDisplayPreferences,
    updatePreferencesOnChange: updatePreferencesOnChange,
    maxContentHeight: maxContentHeight,
    minContentHeight: minContentHeight
  });
});

var TableDisplaySettings =
/*#__PURE__*/
function (_Component) {
  _inherits(TableDisplaySettings, _Component);

  function TableDisplaySettings(props) {
    var _this;

    _classCallCheck(this, TableDisplaySettings);

    _this = _possibleConstructorReturn(this, (TableDisplaySettings.__proto__ || Object.getPrototypeOf(TableDisplaySettings)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "getOptionsFilter", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var searchValue = _this.state.searchValue;
        return function (option) {
          var value = option.label || option.name;
          option = getFullDisplayPreference(option);
          if (!option.configurable) return false;
          return value.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
        };
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "updateVisibilityOfAllOptions", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(isVisible) {
        var options = _this.state.options;
        return options.map(function (item) {
          return _objectSpread({}, item, {
            display: isVisible
          });
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "isAllSelected", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var options = _this.state.options;
        return !!options.length && options.every(function (option) {
          return option.display;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            updatePreferencesOnChange = _this$props.updatePreferencesOnChange,
            updateDisplayPreferences = _this$props.updateDisplayPreferences;
        var options = _this.state.options; // update live on every change

        updatePreferencesOnChange && updateDisplayPreferences(options);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleChangeEnd", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            updatePreferencesOnChange = _this$props2.updatePreferencesOnChange,
            updateDisplayPreferences = _this$props2.updateDisplayPreferences;
        var options = _this.state.options; // update once in the end after all changes

        !updatePreferencesOnChange && updateDisplayPreferences(options);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleSortEnd", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(_ref) {
        var oldIndex = _ref.oldIndex,
            newIndex = _ref.newIndex;
        var options = _this.state.options;

        _this.setState({
          options: arrayMove(options, oldIndex, newIndex)
        }, _this.handleChange);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleChangeInput", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, searchValue) {
        return _this.setState({
          searchValue: searchValue
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleToggleItem", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(item) {
        var options = _this.state.options;

        if (item.name === 'ALL') {
          options = _this.updateVisibilityOfAllOptions(!_this.isAllSelected());
        } else {
          options = options.map(function (option) {
            if (item.name === option.name) {
              return _objectSpread({}, option, {
                display: !item.checked
              });
            }

            return option;
          });
        }

        _this.setState({
          options: options
        }, _this.handleChange);
      }
    });
    _this.state = {
      options: props.options,
      searchValue: ''
    };
    return _this;
  }

  _createClass(TableDisplaySettings, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.options !== this.props.options) {
        this.setState({
          options: nextProps.options
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleChangeEnd();
    } // ------------------------------
    // Helpers
    // ------------------------------

  }, {
    key: "render",
    // ------------------------------
    // Render
    // ------------------------------
    value: function render() {
      var _state = this.state,
          searchValue = _state.searchValue,
          options = _state.options;
      var _props = this.props,
          className = _props.className,
          maxContentHeight = _props.maxContentHeight,
          minContentHeight = _props.minContentHeight;
      var multiSelectData = options.filter(this.getOptionsFilter()).map(function (option) {
        return {
          name: option.name,
          label: option.label || option.name,
          checked: option.display
        };
      });
      return React.createElement("div", {
        className: cx('data-table-filter', className)
      }, React.createElement(SearchField, {
        value: searchValue,
        onChange: this.handleChangeInput
      }), React.createElement(MultiSelectList, {
        data: multiSelectData,
        onSortEnd: this.handleSortEnd,
        isSortable: !searchValue.length,
        onToggleItem: this.handleToggleItem,
        maxContentHeight: maxContentHeight,
        minContentHeight: minContentHeight,
        selectAllEnabled: true
      }));
    }
  }]);

  return TableDisplaySettings;
}(Component);

Object.defineProperty(TableDisplaySettings, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    options: PropTypes.array,
    className: PropTypes.string,
    updateDisplayPreferences: PropTypes.func,
    updatePreferencesOnChange: PropTypes.bool
  }
});
Object.defineProperty(TableDisplaySettings, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    updateDisplayPreferences: function updateDisplayPreferences() {},
    updatePreferencesOnChange: false
  }
});